/* tt-extra-ontwerp (r17extra): Ontwerp 2 to 4 on one garment, as part of the normal order flow.
   The snippet borduur-personalisatie owns the one geometry (TTVoorbeeld.plaats), the photo, the file check and the composite and hands
   them over as root.ttKit. This module owns the extra blocks: upload, side and place, format, and the list window.TTExtras that
   tt-pdp.js reads for the total and for the /cart/add.js call. Each design is { n, side, pos, plek, formaat, file, img, bmp, laag, last }. */
(function () {
  'use strict';
  var root = document.querySelector('[id^="bp-"][data-section]');
  var kit = root && root.ttKit, mount = root && root.querySelector('[data-tt-extra-mount]');
  if (!kit || !mount) return;
  var MAX = Math.min(3, parseInt(mount.dataset.max, 10) || 3), PRICE = parseInt(mount.dataset.price, 10) || 0, VARIANT = mount.dataset.variant || '';
  var money = function (c) { return window.ttMoney ? window.ttMoney(c) : String(c); };

  // places come from the buttons of design 1 (one list of places): [{ side, pos, label }]
  var PLACES = [].map.call(root.querySelectorAll('[data-tt-plek] .bp__plek-btn'), function (b) { return { side: b.dataset.side, pos: b.dataset.pos }; }).filter(function (p) { return p.pos !== 'Overig'; });
  var ORDER = ['Rug midden', 'Borst links', 'Borst midden', 'Borst rechts', 'Rug hoog', 'Rug laag', 'Achterkant boven sluiting', 'Voorkant midden', 'Zijkant links', 'Zijkant rechts'];

  function occupied(side, pos, exN) {
    if (!pos || pos === 'Overig') return 0;
    var d = kit.d1();
    if (d.side === side && d.pos === pos) return 1;
    for (var i = 0; i < kit.extras.length; i++) { var e = kit.extras[i]; if (e.n !== exN && e.side === side && e.pos === pos) return e.n; }
    return 0;
  }
  function freeSpots() { return PLACES.filter(function (p) { return !occupied(p.side, p.pos, 0); }).length; }
  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text) n.textContent = text; return n; }
  function emit() { document.dispatchEvent(new CustomEvent('tt:extra')); }
  function sideOf(e) { return e.side === 'Achterkant' ? 'Achterkant' : 'Voorkant'; }
  function posText(e) { return e.pos === 'Overig' ? (e.plek.trim() || 'Overig') : e.pos; }
  function fmtText(e) { return (e.formaat.label || '').replace(/^tot /, ''); }

  // ---- the add button ----
  var add = el('button', 'tt-ex__add'); add.type = 'button'; add.setAttribute('data-tt-extra-add', '');
  var addTxt = el('span', 'tt-ex__add-t'), addSub = el('span', 'tt-ex__add-sub');
  var plus = el('span', 'tt-ex__plus', '+'); plus.setAttribute('aria-hidden', 'true');
  add.appendChild(plus); add.appendChild(addTxt); add.appendChild(addSub);
  var list = el('div', 'tt-ex__list'); list.setAttribute('data-tt-ex-list', '');
  mount.appendChild(add); mount.appendChild(list);
  function paintAdd() {
    var full = kit.extras.length >= MAX || freeSpots() <= 0;
    var t = full ? 'Meer ontwerpen passen niet' : 'Nog een ontwerp toevoegen', s = full ? '' : money(PRICE) + ' per stuk';
    if (addTxt.textContent !== t) addTxt.textContent = t;
    if (addSub.textContent !== s) addSub.textContent = s;
    if (add.disabled !== full) { add.disabled = full; add.setAttribute('aria-disabled', String(full)); }
  }

  // ---- one block ----
  function build(n) {
    var e = { n: n, side: 'Voorkant', pos: '', plek: '', file: null, img: null, noPreview: false, last: null, errKind: '' };
    var b = el('div', 'tt-ex'); b.setAttribute('data-tt-ex-block', String(n)); e.el = b;
    var head = el('div', 'tt-ex__head'); e.title = el('h3', 'tt-ex__title'); e.title.tabIndex = -1;
    var rm = el('button', 'tt-ex__remove', 'Weghalen'); rm.type = 'button'; rm.setAttribute('data-ex-remove', '');
    rm.addEventListener('click', function () { remove(e); });
    head.appendChild(e.title); head.appendChild(rm); b.appendChild(head);

    // upload: the drop box of design 1, cloned without names, ids and data-bp hooks (nothing of it may reach the form)
    var src = root.querySelector('[data-bp-drop]'), drop = src.cloneNode(true);
    [drop].concat([].slice.call(drop.querySelectorAll('*'))).forEach(function (x) { [].slice.call(x.attributes).forEach(function (a) { if (/^data-bp-/.test(a.name)) x.removeAttribute(a.name); }); });
    [].slice.call(drop.querySelectorAll('input[type=hidden]')).forEach(function (x) { x.remove(); });
    e.fileIn = drop.querySelector('input[type=file]');
    ['name', 'form', 'id'].forEach(function (a) { e.fileIn.removeAttribute(a); });
    e.fileIn.id = 'bp-exfile-' + n + '-' + Date.now().toString(36); drop.setAttribute('for', e.fileIn.id); e.fileIn.setAttribute('data-ex-file', '');
    e.idle = drop.querySelector('.bp__drop-inner:not(.bp__drop-inner--file)'); e.box = drop.querySelector('.bp__drop-inner--file');
    e.thumb = drop.querySelector('.bp__thumb'); e.nameEl = drop.querySelector('.bp__file-name');
    e.idle.hidden = false; e.box.hidden = true; e.thumb.removeAttribute('src'); e.nameEl.textContent = '';
    b.appendChild(el('p', 'bp__label bp__req tt-ex__lbl', 'Bestand voor ontwerp ' + n)); e.lbl = b.lastChild;
    b.appendChild(drop);
    e.errFile = el('div', 'bp__err', ''); e.errFile.hidden = true; e.errFile.setAttribute('role', 'alert'); e.errFile.setAttribute('data-ex-err-file', '');
    b.appendChild(e.errFile);
    e.notices = el('div', 'bp__notices'); b.appendChild(e.notices);

    // place: the place buttons of design 1 (same list, same labels)
    b.appendChild(el('p', 'bp__label bp__req tt-ex__lbl', 'Plek'));
    var pl = root.querySelector('[data-tt-plek]').cloneNode(true);
    pl.removeAttribute('data-tt-plek'); pl.removeAttribute('aria-labelledby'); pl.setAttribute('data-ex-plek', '');
    [].forEach.call(pl.querySelectorAll('.bp__plek-btn'), function (x) {
      x.classList.remove('is-active'); x.setAttribute('aria-pressed', 'false');
      x.addEventListener('click', function () {
        if (x.disabled) return;
        e.pos = x.dataset.pos; if (x.dataset.side) e.side = x.dataset.side; fitEx(e);
        e.errKind = ''; e.errPlek.hidden = true; focusEx(e); emit();
      });
    });
    e.plekBtns = [].slice.call(pl.querySelectorAll('.bp__plek-btn')); b.appendChild(pl);
    e.where = el('input', 'bp__text'); e.where.type = 'text'; e.where.hidden = true; e.where.placeholder = 'Geef hier duidelijk aan waar je dit ontwerp wilt hebben.'; e.where.setAttribute('data-ex-where', ''); e.where.setAttribute('aria-label', 'Waar komt ontwerp ' + n);
    e.where.addEventListener('input', function () { e.plek = e.where.value; e.errKind = ''; e.errPlek.hidden = true; emit(); });
    b.appendChild(e.where);
    e.errPlek = el('div', 'bp__err'); e.errPlek.hidden = true; e.errPlek.setAttribute('role', 'alert'); e.errPlek.setAttribute('data-ex-err-plek', ''); b.appendChild(e.errPlek);

    // format: the format buttons of design 1 (their data-cents and data-variant are the surcharge of this design)
    b.appendChild(el('p', 'bp__label tt-ex__lbl', 'Formaat'));
    var fm = root.querySelector('[data-bp-formaat]').cloneNode(true);
    fm.removeAttribute('data-bp-formaat'); fm.setAttribute('data-ex-fmt', '');
    e.fmtBtns = [].slice.call(fm.querySelectorAll('.bp__swatch'));
    e.fmtBtns.forEach(function (x, i) {
      x.classList.toggle('is-active', i === 0);
      x.addEventListener('click', function () { setFmt(e, x); focusEx(e); emit(); });
    });
    setFmt(e, e.fmtBtns[0]); b.appendChild(fm);

    // events
    e.fileIn.addEventListener('change', function () { var f = e.fileIn.files && e.fileIn.files[0]; if (f) load(e, f); });
    b.addEventListener('focusin', function () { if (kit.focusN !== e.n) focusEx(e); });
    // the layer and its bitmap
    e.bmp = document.createElement('canvas'); e.laag = el('div', 'tt-vb-laag'); e.laag.setAttribute('data-tt-voorbeeld-laag', String(n)); e.laag.hidden = true; e.laag.appendChild(e.bmp);
    e.missing = function () { return missingOf(e); };
    return e;
  }
  // the place's data-fmt-max (cm wide) disables larger formats of this design, as on design 1
  function fitEx(e) {
    var b = e.plekBtns.filter(function (x) { return x.dataset.pos === e.pos && (!x.dataset.side || x.dataset.side === e.side); })[0];
    var lim = b && b.dataset.fmtMax ? parseFloat(b.dataset.fmtMax) : 0, fit = null;
    e.fmtBtns.forEach(function (x) { var off = !!lim && parseFloat(x.dataset.maxw) > lim; x.disabled = off; x.setAttribute('aria-disabled', off ? 'true' : 'false'); if (!off) fit = x; });
    var act = e.fmtBtns.filter(function (x) { return x.classList.contains('is-active'); })[0];
    if (act && act.disabled && fit) setFmt(e, fit);
  }
  function setFmt(e, btn) {
    e.fmtBtns.forEach(function (x) { var on = x === btn; x.classList.toggle('is-active', on); });
    e.formaat = { value: btn.dataset.value, maxW: parseFloat(btn.dataset.maxw), maxH: parseFloat(btn.dataset.maxh), cents: parseInt(btn.dataset.cents, 10) || 0, variant: btn.dataset.variant || '', label: kit.nice(btn.dataset.value) };
  }
  function focusEx(e) {
    var changed = kit.focusN !== e.n || kit.st.view !== sideOf(e);
    kit.focusN = e.n; if (changed) kit.view(sideOf(e));
    kit.update();
  }

  // ---- files: the same checks as design 1 (kit.fileProblem), the same bitmap (kit.bitmap) ----
  function showName(e, file, url) {
    e.nameEl.textContent = file.name;
    if (url) { e.thumb.src = url; e.thumb.hidden = false; } else { e.thumb.removeAttribute('src'); e.thumb.hidden = true; }
    e.idle.hidden = true; e.box.hidden = false; e.errFile.hidden = true;
  }
  function note(e, text) { var d = el('div', 'bp__notice', text); e.notices.appendChild(d); }
  function reject(e, text) {
    try { e.fileIn.value = ''; } catch (x) {}
    e.file = null; e.img = null; e.noPreview = false; e.thumb.removeAttribute('src'); e.nameEl.textContent = '';
    e.box.hidden = true; e.idle.hidden = false;
    if (text) { e.errFile.textContent = text; e.errFile.hidden = false; }
    kit.update(); emit();
  }
  function load(e, file) {
    e.notices.textContent = ''; e.errFile.hidden = true; e.img = null; e.noPreview = false;
    var pr = kit.fileProblem(file);
    if (pr.error) { reject(e, pr.error); return; }
    e.file = file;
    if (pr.noPreview) { e.noPreview = true; showName(e, file, ''); note(e, root.dataset.nNopreview); focusEx(e); emit(); return; }
    var url = URL.createObjectURL(file), img = new Image();
    img.onload = function () {
      var r = kit.bitmap(img, file, false, e.bmp);
      if (r.empty) { reject(e, root.dataset.nEmpty); return; }
      e.img = img; e.ratio = r.ratio; showName(e, file, url);
      kit.quality(img, file, function (t) { note(e, t); });
      focusEx(e); emit();
    };
    img.onerror = function () { reject(e, root.dataset.nLoad); };
    img.src = url;
  }

  // ---- what is still to choose (submit validation and the buy bar read this through the snippet's missing()) ----
  function missingOf(e) {
    var m = [], sel = '[data-tt-ex-block="' + e.n + '"] ';
    if (!e.file) { e.errFile.textContent = 'Upload eerst het bestand voor ontwerp ' + e.n + '.'; m.push({ name: 'ontwerp ' + e.n, err: sel + '[data-ex-err-file]', el: e.fileIn }); }
    var other = occupied(sideOf(e), e.pos, e.n);
    if (!e.pos) { e.errPlek.textContent = 'Kies een plek voor ontwerp ' + e.n + '.'; e.errKind = 'miss'; m.push({ name: 'plek ontwerp ' + e.n, err: sel + '[data-ex-err-plek]', el: e.plekBtns.filter(function (b) { return !b.disabled; })[0] || e.plekBtns[0] }); }
    else if (other) { e.errPlek.textContent = 'Ontwerp ' + other + ' staat al op deze plek. Kies een andere plek voor ontwerp ' + e.n + '.'; e.errKind = 'coll'; m.push({ name: 'plek ontwerp ' + e.n, err: sel + '[data-ex-err-plek]', el: e.plekBtns.filter(function (b) { return !b.disabled; })[0] || e.plekBtns[0] }); }
    else if (e.pos === 'Overig' && !e.plek.trim()) { e.errPlek.textContent = 'Geef aan waar ontwerp ' + e.n + ' komt.'; e.errKind = 'miss'; m.push({ name: 'waar ontwerp ' + e.n, err: sel + '[data-ex-err-plek]', el: e.where }); }
    return m;
  }

  // ---- repaint after every update of the snippet: taken places, collisions, pressed state (write only on change) ----
  function setAttrIf(n, a, v) { if (n.getAttribute(a) !== v) n.setAttribute(a, v); }
  kit.sync = function () {
    kit.extras.forEach(function (e) {
      e.plekBtns.forEach(function (b) {
        var pos = b.dataset.pos, side = b.dataset.side, other = pos === 'Overig' ? 0 : occupied(side, pos, e.n);
        var on = !!e.pos && pos === e.pos && (pos === 'Overig' || side === e.side);
        if (b.disabled !== !!other) { b.disabled = !!other; setAttrIf(b, 'aria-disabled', String(!!other)); }
        var tt = other ? 'Bezet door ontwerp ' + other : ''; if ((b.getAttribute('title') || '') !== tt) { if (tt) b.setAttribute('title', tt); else b.removeAttribute('title'); }
        if (b.classList.contains('is-active') !== on) b.classList.toggle('is-active', on);
        setAttrIf(b, 'aria-pressed', String(on));
      });
      var wantWhere = e.pos === 'Overig'; if (e.where.hidden === wantWhere) e.where.hidden = !wantWhere;
      var other2 = occupied(sideOf(e), e.pos, e.n);
      if (other2) {
        var t = 'Ontwerp ' + other2 + ' staat al op deze plek. Kies een andere plek voor ontwerp ' + e.n + '.';
        if (e.errPlek.textContent !== t) e.errPlek.textContent = t;
        e.errKind = 'coll'; if (e.errPlek.hidden) e.errPlek.hidden = false;
      } else if (e.errKind === 'coll') { e.errKind = ''; if (!e.errPlek.hidden) e.errPlek.hidden = true; }
      if (e.fmtBtns) e.fmtBtns.forEach(function (x) { setAttrIf(x, 'aria-pressed', String(x.classList.contains('is-active'))); });
    });
    paintAdd();
  };

  // ---- add and remove ----
  function renumber() {
    kit.extras.sort(function (a, b) { return a.n - b.n; });
    kit.extras.forEach(function (e, i) {
      e.n = i + 2; e.el.setAttribute('data-tt-ex-block', String(e.n)); e.title.textContent = 'Ontwerp ' + e.n;
      e.lbl.textContent = 'Bestand voor ontwerp ' + e.n; e.laag.setAttribute('data-tt-voorbeeld-laag', String(e.n));
    });
  }
  function addBlock() {
    if (kit.extras.length >= MAX || freeSpots() <= 0) return;
    var e = build(kit.extras.length + 2);
    kit.extras.push(e); list.appendChild(e.el); renumber();
    // the first free place, back first (a second design usually goes on the other side)
    var pick = ORDER.filter(function (p) { return PLACES.some(function (x) { return x.pos === p && !occupied(x.side, p, e.n); }); })[0];
    if (pick) { var pp = PLACES.filter(function (x) { return x.pos === pick; })[0]; e.pos = pick; e.side = pp.side; fitEx(e); }
    kit.focusN = e.n; kit.view(sideOf(e)); kit.update(); emit();
    try { e.title.focus({ preventScroll: true }); e.el.scrollIntoView({ block: 'nearest', behavior: 'auto' }); } catch (x) {}
  }
  function remove(e) {
    var i = kit.extras.indexOf(e); if (i < 0) return;
    kit.extras.splice(i, 1); e.el.remove(); e.laag.remove();
    renumber(); kit.focusN = 1; kit.view(null); kit.update(); emit();
    try { add.focus({ preventScroll: true }); } catch (x) {}
  }
  add.addEventListener('click', addBlock);

  // ---- what tt-pdp.js reads ----
  window.TTExtras = {
    variant: VARIANT, price: PRICE,
    items: function () { return kit.extras.map(function (e) { return { n: e.n, side: sideOf(e), pos: e.pos, plek: e.plek.trim(), fmt: e.formaat, file: e.file }; }); },
    // cents for ONE piece: the price per design plus the format surcharge of each design
    perPiece: function () { return kit.extras.reduce(function (s, e) { return s + PRICE + (e.formaat ? e.formaat.cents : 0); }, 0); },
    summary: function () { return kit.extras.map(function (e) { return e.n + ': ' + posText(e) + ', ' + fmtText(e); }).join('; '); },
    posText: function (e) { return posText(e); },
    // r18terug: rebuild the blocks of a design list after "back" from the cart: [{ side, pos, fmt, file }] (file is a File already fetched).
    // Only when no block exists yet; a position that is not one of the place buttons is a free-text place (Overig). Returns the number of blocks made.
    restore: function (rows) {
      if (kit.extras.length || !rows || !rows.length) return 0;
      var made = 0;
      rows.slice(0, MAX).forEach(function (d) {
        var before = kit.extras.length; addBlock();
        if (kit.extras.length === before) return;
        var e = kit.extras[kit.extras.length - 1], hit = PLACES.filter(function (p) { return p.pos === d.pos && p.side === d.side; })[0] || PLACES.filter(function (p) { return p.pos === d.pos; })[0];
        if (hit) { e.pos = hit.pos; e.side = hit.side; }
        else { e.pos = 'Overig'; e.plek = String(d.pos || ''); e.where.value = e.plek; e.side = d.side === 'Achterkant' ? 'Achterkant' : 'Voorkant'; }
        var fb = e.fmtBtns.filter(function (x) { return kit.nice(x.dataset.value) === d.fmt; })[0];
        if (fb) { e.fmtBtns.forEach(function (x) { x.classList.toggle('is-active', x === fb); }); setFmt(e, fb); }
        if (d.file) { try { var dt = new DataTransfer(); dt.items.add(d.file); e.fileIn.files = dt.files; } catch (x) {} e.fileIn.dispatchEvent(new Event('change', { bubbles: true })); }
        made++;
      });
      kit.focusN = 1; kit.view(null); kit.update(); emit();
      return made;
    }
  };
  paintAdd();
})();
